import React from "react";
import "../styles/Credits.css";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class Credits extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    return (
      <FadeInSection>
        <div className="about-description">
        <br /><br /><br /><br />
        </div>
        <div id="credits">
          <div className="ending-credits">
            
          <div> © 2024 GroupMatch</div>
            <div>Built and designed by Samiya Islam. </div>
            <div>All rights reserved.</div>
          </div>
        </div>
      </FadeInSection>
    );
  }
}

export default Credits;
